import React from 'react';
import { Form } from '@ant-design/compatible';
import CheckBoxGroup from '../../input/CheckBoxGroup';
import cx from 'classnames';
import './CheckBoxGroupForm.scss';

const CheckBoxGroupForm = (props) => {
  const { className, form, label, rules, name, list, initialValue, onChange, disabled } = props;
  const { getFieldDecorator } = form;

  return (
    <Form.Item className={cx('checkbox-form-group', 'amondz-form', className, { 'with-label': label })} label={label}>
      {getFieldDecorator(name, {
        rules,
        initialValue,
        onChange,
      })(<CheckBoxGroup list={list} onChange={onChange} size="large" disabled={disabled} />)}
    </Form.Item>
  );
};

export default CheckBoxGroupForm;
